export default __webpack_public_path__ + "8fc6e6a197a061995b2347af180c53f5.png";